import { Box, CircularProgress } from "@mui/material";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "../Redux/hooks";

const AuthHydrationLoader = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    }}
  >
    <CircularProgress color="primary" />
  </Box>
);

type Props = {
  children?: JSX.Element | JSX.Element[];
  //Pass any array of roles that have access to the route
  disallowedRoles?: string[];
  allowedRoles?: string[];
};
type StudyProps = {
  children?: JSX.Element | JSX.Element[];
  //Pass any array of roles that have access to the route
  action?: string;
  feature?: string;
};

type PlatformProps = {
  children?: JSX.Element | JSX.Element[];
  action?: string;
};

export const AuthenticatedRoute: React.FC<Props> = ({
  children,
  allowedRoles,
  disallowedRoles,
}) => {
  const { isUserAuthenticated, role, authHydrated } = useAppSelector(
    (state) => state.user
  );

  if (!authHydrated) {
    return <AuthHydrationLoader />;
  }

  if (!isUserAuthenticated) {
    return <Navigate to="/auth/login" />;
  }

  if (disallowedRoles && disallowedRoles.includes(role)) {
    return <Navigate to="/home" />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/home" />;
  }

  return <>{children}</>;
};

export const UnAuthenticatedRoute: React.FC<any> = ({ children }) => {
  const { isUserAuthenticated, authHydrated } = useAppSelector(
    (state) => state.user
  );

  if (!authHydrated) {
    return <AuthHydrationLoader />;
  }

  return isUserAuthenticated ? <Navigate to="/home" /> : <>{children}</>;
};

export const StudyAuthenticatedRoute: React.FC<StudyProps> = ({
  children,
  action,
  feature,
}) => {
  const { isUserAuthenticated } = useAppSelector((state) => state.user);
  const { studyPermissions } = useAppSelector((state) => state.study);
  const features = useAppSelector((state) => state.study.features);
  if (!isUserAuthenticated) {
    return <Navigate to="/auth/login" />;
  }

  if (action && !studyPermissions.includes(action)) {
    return <Navigate to="/app/studies" />;
  }

  if (feature && !features?.[feature]) {
    return <Navigate to="/app/studies" />;
  }

  return <>{children}</>;
};

export const PlatformAuthenticatedRoute: React.FC<PlatformProps> = ({
  children,
  action,
}) => {
  const { isUserAuthenticated, platformPermissions } = useAppSelector(
    (state) => state.user
  );

  if (!isUserAuthenticated) {
    return <Navigate to="/auth/login" />;
  }
  if (action && !platformPermissions.includes(action)) {
    return <Navigate to="/app/studies" />;
  }

  return <>{children}</>;
};
